import { clsx } from 'clsx';
import QuestionMarkCircle from '@crehana/compass.icons.fill/QuestionMarkCircle';
import { Tooltip } from "../../../Tooltip";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Label = function Label(_ref) {
  var label = _ref.label,
    tooltip = _ref.tooltip,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'sm' : _ref$size,
    state = _ref.state;
  return /*#__PURE__*/_jsxs("div", {
    className: clsx('tw-flex tw-items-center tw-gap-0.8', size === 'sm' ? 'tw-font-subtitle5' : 'tw-font-subtitle4', state === 'disabled' ? 'dark:tw-text-neutral-dark-600' : 'dark:tw-text-neutral-light-100'),
    children: [/*#__PURE__*/_jsx("span", {
      children: label
    }), tooltip && /*#__PURE__*/_jsx(Tooltip, {
      type: "small",
      label: tooltip,
      position: "top",
      children: /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(QuestionMarkCircle, {
          size: 16,
          className: clsx('tw-text-neutral-light-600 tw-flex tw-items-center', state === 'disabled' && 'dark:tw-text-neutral-dark-600')
        })
      })
    })]
  });
};
export default Label;